import { useContext, useState } from "react";
import { ThemeContext } from "../../../context/theme-context";
import { ISelect } from "../../../redux/features/inventary/services/object";
import { IStore } from "../../../Components/Configuracao/interface/store";
import { Container } from "react-bootstrap";
import { IInventary } from "../../../redux/features/inventary/interface";
import { ListContagem } from "../../../Components/Estoque/contagem/ListContagem";
import { FormContagem } from "../../../Components/Estoque/contagem/FormContagem";

export interface IListInventary {
  onEditItem: (item: IInventary) => void;
  onAddNewCli: (e: boolean) => void;
  inventaryData?: any;
  title: string;
}

export interface IFormInventary {
  title: string;
  OnAddNewInventary: (e: boolean) => void;
  inventaryData?: any;
  editando: boolean;
}

export interface ISelectOptions {
  type: ISelect[];
  store: IStore[];
}

export function CardContagem() {
  const { collapsed } = useContext(ThemeContext);
  const [cad, setCad] = useState<boolean>(false);
  const [toEditInventary, setToEditInventary] = useState<{}>({});
  const [editando, setEditando] = useState<boolean>(false);

  const handleNew = (e: boolean) => {
    setEditando(false);
    setToEditInventary({});
    setCad(e);
  };

  const handleEdit = (props: IInventary) => {
    setToEditInventary(props);
    setCad(true);
    setEditando(true);
  };

  return (
    <>
      {!cad ? (
        <Container
          className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
        >
          <ListContagem
            title={"Contagem de Estoque"}
            onEditItem={(item: IInventary) => handleEdit(item)}
            inventaryData={toEditInventary}
            onAddNewCli={(e: boolean) => {
              handleNew(e);
            }}
          />
        </Container>
      ) : (
        <Container
          className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
        >
          <FormContagem
            title={
              toEditInventary
                ? "Criar Contagem de Estoque"
                : "Editar Contagem de Estoque"
            }
            OnAddNewInventary={(e: boolean) => handleNew(e)}
            inventaryData={toEditInventary}
            editando={editando}
          />
        </Container>
      )}
    </>
  );
}
